import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SskSelectOrderTypeComponent } from './ssk-note-modal.component';
import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
//---------------------------------------------------------------------------------
import { InputFocusDirectiveModule } from 'src/app/directives/input-focus-directive/input-focus-directive.module';
import { DeliveryTypeTranslationPipeModule } from 'src/app/pipes/delivery-type-translation/delivery-type-translation-pipe.module';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [SskSelectOrderTypeComponent],
  imports: [
    CommonModule,
    IonicModule,
    FontAwesomeModule,
    InputFocusDirectiveModule,
    DeliveryTypeTranslationPipeModule,
    TranslocoModule
  ]
})
export class SskNoteModalModule {}
